/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'
 
import main from './main_store/main_store';
import auth from './auth';
import profile from './profile/profile'; 

Vue.use(Vuex)

export default new Vuex.Store({ 
  modules: {
    main,
    auth,
    profile,
    // other modules here ...
  }
});

// export default new Vuex.Store({
//     getters,
//     mutations,
//     state,
//     actions,
//     strict: process.env.NODE_ENV !== 'production'
// })
